import * as React from 'react';
import { UIHeading2, Body1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface INewYearLayout {
  title?: React.ReactChild;
  content?: React.ReactChild;
  action?: React.ReactChild;
}

export const NewYearAlertLayout: React.FC<INewYearLayout> = props => {
  const { title, content, action } = props;

  return (
    <div className={styles['container']} data-testid="new-year-layout">
      {title && (
        <div className={styles['title-area']}>
          <UIHeading2>{title}</UIHeading2>
        </div>
      )}
      {content && (
        <div className={styles['content-area']}>
          <Body1>{content}</Body1>
        </div>
      )}
      {action && <div className={styles['action-area']}>{action}</div>}
    </div>
  );
};
